export default __webpack_public_path__ + "static/media/school-bus-management-compressed.ce6a9b88.jpg";